import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
};

const pendingOverweightSlice = createSlice({
  name: 'orderOverweightUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, resetFilters } = pendingOverweightSlice.actions;
const allPendingOverweightReducer = pendingOverweightSlice.reducer;
export default allPendingOverweightReducer;
